import { useToken } from 'utils/hooks/useToken'
import { WalletBalancesCSS } from './WalletBalancesCSS.styled'
import { useConvertAmount } from 'utils/hooks'
import { useUser } from 'hooks/user/useUser'
import { useCallback } from 'react'
import { config } from 'config/index'
import { currencyFormatter } from 'utils'
import { useLvgLiveOrdersAmount } from 'hooks/games/lvg/useYourBidsOrders'

const { DEFAULT_FIAT } = config

export const WalletBalances = () => {
  const { tokenId, formatToken } = useToken()
  const { liveOrdersAmount } = useLvgLiveOrdersAmount()
  // const { isProxy } = useUser('wallet')

  const convert = useConvertAmount()

  const { totalBalance } = useUser('balance')

  const convertFromTokenToUSD = useCallback(
    (amountBN) => convert(formatToken(amountBN), tokenId, DEFAULT_FIAT, { number: true }),
    [tokenId, convert, formatToken]
  )

  return (
    <WalletBalancesCSS>
      <div className='wallet_page_balance_wrapper'>
        <div className='wallet_page_balance'>
          <div className='available_balance_wrapper'>
            <strong>Available balance</strong>
            <div className='balance_value available_balance_value'>
              {currencyFormatter(convertFromTokenToUSD(totalBalance), { useLongNumber: true })}
              <span className='currency_type usd'>USD</span>
            </div>
          </div>

          <div className='total_balance_wrapper'>
            <strong>Total Net balance</strong>
            <div className='balance_value'>
              {currencyFormatter(convertFromTokenToUSD(totalBalance) + Number(liveOrdersAmount.potentialAmount), {
                useLongNumber: true,
              })}
              <span className='currency_type usd'>USD</span>
            </div>
          </div>
        </div>
      </div>
    </WalletBalancesCSS>
  )
}
